<div (click)="open(data)" [class]="'h-56 shadow-sm cursor-pointer active:translate-y-2 transition-all select-none rounded-2xl bg-gray-50 flex justify-end p-4 items-end flex-col hover:text-['+(data.color?(data.color):'#FFF')+']'">
    <div class="w-full h-full flex items-center justify-center">
        <img style="max-width: 9rem;" class="w-full " [src]="data.src" alt="">

    </div>
    <h5 class="text-lg lg:text-3xl text-gray-900 font-semibold ">{{data.name}}</h5>
</div>
